import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

export default function Header() {
  const location = useLocation();
  
  const navItems = [
    { label: 'Gallery', path: '/gallery' },
    { label: 'Services', path: '/services' },
    { label: 'About', path: '/about' },
    { label: 'FAQs', path: '/faqs' },
    { label: 'Contact', path: '/contact' }
  ];

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur border-b" data-testid="site-header">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl h-16 flex items-center justify-between">
        <Link 
          to="/" 
          className="text-lg font-semibold tracking-wide text-foreground hover:text-primary transition-colors"
          data-testid="brand-home-link"
        >
          Interio Mart
        </Link>
        
        <nav aria-label="Primary" className="hidden md:block">
          <ul className="flex items-center gap-1">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`px-3 py-2 text-sm uppercase tracking-wide transition-colors hover:text-foreground ${
                    location.pathname === item.path 
                      ? 'text-foreground font-medium' 
                      : 'text-muted-foreground'
                  }`}
                  data-testid={`nav-${item.label.toLowerCase()}-link`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        
        <div className="flex items-center gap-2">
          <Link to="/contact">
            <Button 
              className="transition-colors duration-200"
              data-testid="get-quote-button"
            >
              Get Quote
            </Button>
          </Link>
          <a
            href="https://wa.me/918310951921"
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-accent hover:bg-muted transition-colors duration-200"
            data-testid="header-whatsapp-button"
          >
            <MessageCircle className="h-5 w-5" />
          </a>
        </div>
      </div>
    </header>
  );
}